import { format } from 'date-fns';

export const formatDateUK = (date) => {
  if (!date) return '';
  try {
    return format(new Date(date), 'dd-MM-yyyy HH:mm');
  } catch {
    return '';
  }
};
